import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class GbVerifyIdentityService {
  private identityReadySubject$ = new BehaviorSubject<boolean>(false)
  identityReady$ = this.identityReadySubject$.asObservable()

  identity = ''
  uuid = ''

  setIdentity(identity: string, uuid: string): void {
    this.identity = identity
    this.uuid = uuid
    this.identityReadySubject$.next(true)
  }

  clearIdentity(): void {
    this.identity = ''
    this.uuid = ''
    this.identityReadySubject$.next(false)
  }
}
